// Requires drawer.js (DrawerBase) to be loaded first — see snippets/collection-filters.liquid.
// Mobile drawer for the collection filter sidebar, opened by any button with
// aria-controls pointing at this element's id.
class FilterDrawer extends window.DrawerBase {
  connectedCallback() {
    if (!this.initialized) {
      this.initialized = true;

      this.initDrawer({
        overlay: this.querySelector('.collection-sidebar__overlay'),
        content: this.querySelector('.collection-sidebar__content'),
      });

      this.onDesktopChange = (event) => {
        if (event.matches) this.reset();
      };

      this.onTriggerClick = () => this.open();
      // Created once: matchMedia returns a fresh MediaQueryList each call, and
      // disconnectedCallback removes the listener from this same object.
      this.desktopMedia = window.matchMedia('(min-width: 768px)');

      const closeBtn = this.querySelector('.collection-sidebar__close');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    }

    // Reset drawer state when resizing up to desktop (the 768px counterpart of
    // the 767px media query in collection-filters.liquid) so the page isn't
    // left scroll-locked. Idempotent with the cached handler reference.
    this.desktopMedia.addEventListener('change', this.onDesktopChange);

    // Re-query the trigger on every connect: after a section re-render the old
    // trigger button may have been replaced, so a cached reference could go
    // stale and leave the new button dead. addEventListener is idempotent with
    // the cached handler reference.
    this.trigger = document.querySelector(`[aria-controls="${this.id}"]`);
    if (this.trigger) this.trigger.addEventListener('click', this.onTriggerClick);
  }

  disconnectedCallback() {
    this.reset();
    this.desktopMedia.removeEventListener('change', this.onDesktopChange);
    if (this.trigger) this.trigger.removeEventListener('click', this.onTriggerClick);
  }

  onAfterOpen() {
    document.addEventListener('keydown', this.onEscapeKeydown);
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
  }

  onAfterCloseStart() {
    document.removeEventListener('keydown', this.onEscapeKeydown);
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
  }

  reset() {
    this.classList.remove('closing');
    this.removeAttribute('open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', this.onEscapeKeydown);
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('filter-drawer')) {
  customElements.define('filter-drawer', FilterDrawer);
}
